import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apps } from '../data/apps-privacy-policy';

const AppsPrivacyPolicyListPage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white px-6 py-24 sm:py-32 lg:px-8 max-w-7xl mx-auto">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">{t('apps_privacy_policy.title')}</h2>
        <p className="mt-6 text-lg leading-8 text-gray-600">
          {t('apps_privacy_policy.intro')}
        </p>
      </div>
      <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        {apps.map((app) => (
          <article key={app.id} className="flex flex-col items-start justify-between">
            <div className="relative w-full">
              <img
                src={app.imageUrl}
                alt=""
                className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
            </div>
            <div className="max-w-xl">
              <div className="group relative">
                <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                  <Link to={`/apps-privacybeleid/${app.id}`}>
                    <span className="absolute inset-0" />
                    {app.name}
                  </Link>
                </h3>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default AppsPrivacyPolicyListPage; 